/**
 * 時區相關工具函數
 * 提供瀏覽器時區偵測、驗證和處理功能
 */

/**
 * 獲取瀏覽器當前時區
 * @returns {string} 時區名稱 (例如: 'Asia/Taipei', 'America/New_York')
 */
export const getBrowserTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (error) {
    console.warn('Failed to detect browser timezone:', error);
    return 'UTC'; // 預設返回 UTC
  }
};

/**
 * 驗證時區名稱是否有效
 * @param {string} timezone - 時區名稱
 * @returns {boolean} 是否為有效時區
 */
export const isValidTimezone = (timezone) => {
  if (!timezone || typeof timezone !== 'string') {
    return false;
  }

  try {
    // 使用 Intl.DateTimeFormat 驗證時區
    Intl.DateTimeFormat(undefined, { timeZone: timezone });
    return true;
  } catch (error) {
    return false;
  }
};

/**
 * 將 IANA 時區名稱轉為簡短顯示格式
 * @param {string} timezone - 時區名稱 (例如: 'Asia/Seoul', 'America/New_York')
 * @returns {string|null} 簡短格式 (例如: 'UTC+9', 'UTC-5') 或 null
 */
export const formatTimezoneShort = (timezone) => {
  if (!timezone) return null;
  try {
    const now = new Date();
    const formatter = new Intl.DateTimeFormat('en-US', { timeZone: timezone, timeZoneName: 'shortOffset' });
    const parts = formatter.formatToParts(now);
    const offsetPart = parts.find(p => p.type === 'timeZoneName');
    return offsetPart?.value?.replace('GMT', 'UTC') || null;
  } catch {
    return null;
  }
};

/**
 * 注意：主要的時區功能已移至 globalTimezone.js
 * 此文件保留基本的時區工具函數供其他模組使用
 */